// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f710e0eb","answerBooleanContainer":"cd0ecf0a"};